import { html, when } from '@genesislcap/web-core';
import type { PrincipalAmountModal } from './principal-amount-modal';
import { formatPrincipalAmountForModal } from '../deal-series.util';

export const principalAmountModalTemplate = html<PrincipalAmountModal>`
  ${when(
    (x) => x.visible && x.principalAmount,
    html<PrincipalAmountModal>`
      <div
        class="principal-amount-panel"
        style="position: fixed; top: ${(x) => x.anchorTop}px; left: ${(x) => x.anchorLeft}px;"
        data-test-id="principal-amount-modal"
      >
        <span class="principal-amount-label">Principle Amt</span>
        <span
          class="principal-amount-value ${(x) => (x.valueHighlighted ? 'principal-amount-value--highlighted' : '')}"
        >
          ${(x) => formatPrincipalAmountForModal(x.principalAmount)}
        </span>
      </div>
    `,
  )}
`;
